const serializationThingsDB = thing => {
  const data = structuredClone(thing)
  data.info = JSON.stringify(thing.info)
  data.config = JSON.stringify(thing.config)
  data.metadata = JSON.stringify(thing.metadata)
  data.reported_state = JSON.stringify(thing.reported_state)
  return data
}

const deserializationThingsDB = thing => {
  thing.info = JSON.parse(thing.info)
  thing.config = JSON.parse(thing.config)
  thing.metadata = JSON.parse(thing.metadata)
  thing.reported_state = JSON.parse(thing.reported_state)
}

export { serializationThingsDB, deserializationThingsDB }
